import { useSyncExternalStore } from "react"

const empty: Record<string, string> = {}
let bookIndexes = empty
const listeners = new Set<()=> void>()

export function getBookIndexesSnapshot() {
  return bookIndexes
}

export function setBookIndexes(next: Record<string, string>) {
  bookIndexes = next
  for (const listener of listeners) {
    listener()
  }
}

export function useBookIndexes() {
  return useSyncExternalStore(
    subscribe,
    getBookIndexesSnapshot,
    getBookIndexesSnapshot,
  )
}

function subscribe(listener: ()=> void) {
  listeners.add(listener)
  return ()=> {
    listeners.delete(listener)
  }
}
